var oe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var le = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(oe, function() {
    var r = 1e3, n = 6e4, a = 36e5, l = "millisecond", o = "second", $ = "minute", y = "hour", M = "day", A = "week", F = "month", J = "quarter", x = "year", U = "date", d = "Invalid Date", C = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, _ = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, L = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(f) {
      var c = ["th", "st", "nd", "rd"], i = f % 100;
      return "[" + f + (c[(i - 20) % 10] || c[i] || c[0]) + "]";
    } }, v = function(f, c, i) {
      var u = String(f);
      return !u || u.length >= c ? f : "" + Array(c + 1 - u.length).join(i) + f;
    }, K = { s: v, z: function(f) {
      var c = -f.utcOffset(), i = Math.abs(c), u = Math.floor(i / 60), s = i % 60;
      return (c <= 0 ? "+" : "-") + v(u, 2, "0") + ":" + v(s, 2, "0");
    }, m: function f(c, i) {
      if (c.date() < i.date())
        return -f(i, c);
      var u = 12 * (i.year() - c.year()) + (i.month() - c.month()), s = c.clone().add(u, F), h = i - s < 0, m = c.clone().add(u + (h ? -1 : 1), F);
      return +(-(u + (i - s) / (h ? s - m : m - s)) || 0);
    }, a: function(f) {
      return f < 0 ? Math.ceil(f) || 0 : Math.floor(f);
    }, p: function(f) {
      return { M: F, y: x, w: A, d: M, D: U, h: y, m: $, s: o, ms: l, Q: J }[f] || String(f || "").toLowerCase().replace(/s$/, "");
    }, u: function(f) {
      return f === void 0;
    } }, N = "en", k = {};
    k[N] = L;
    var P = "$isDayjsObject", Z = function(f) {
      return f instanceof Q || !(!f || !f[P]);
    }, Y = function f(c, i, u) {
      var s;
      if (!c)
        return N;
      if (typeof c == "string") {
        var h = c.toLowerCase();
        k[h] && (s = h), i && (k[h] = i, s = h);
        var m = c.split("-");
        if (!s && m.length > 1)
          return f(m[0]);
      } else {
        var p = c.name;
        k[p] = c, s = p;
      }
      return !u && s && (N = s), s || !u && N;
    }, O = function(f, c) {
      if (Z(f))
        return f.clone();
      var i = typeof c == "object" ? c : {};
      return i.date = f, i.args = arguments, new Q(i);
    }, g = K;
    g.l = Y, g.i = Z, g.w = function(f, c) {
      return O(f, { locale: c.$L, utc: c.$u, x: c.$x, $offset: c.$offset });
    };
    var Q = function() {
      function f(i) {
        this.$L = Y(i.locale, null, !0), this.parse(i), this.$x = this.$x || i.x || {}, this[P] = !0;
      }
      var c = f.prototype;
      return c.parse = function(i) {
        this.$d = function(u) {
          var s = u.date, h = u.utc;
          if (s === null)
            return /* @__PURE__ */ new Date(NaN);
          if (g.u(s))
            return /* @__PURE__ */ new Date();
          if (s instanceof Date)
            return new Date(s);
          if (typeof s == "string" && !/Z$/i.test(s)) {
            var m = s.match(C);
            if (m) {
              var p = m[2] - 1 || 0, D = (m[7] || "0").substring(0, 3);
              return h ? new Date(Date.UTC(m[1], p, m[3] || 1, m[4] || 0, m[5] || 0, m[6] || 0, D)) : new Date(m[1], p, m[3] || 1, m[4] || 0, m[5] || 0, m[6] || 0, D);
            }
          }
          return new Date(s);
        }(i), this.init();
      }, c.init = function() {
        var i = this.$d;
        this.$y = i.getFullYear(), this.$M = i.getMonth(), this.$D = i.getDate(), this.$W = i.getDay(), this.$H = i.getHours(), this.$m = i.getMinutes(), this.$s = i.getSeconds(), this.$ms = i.getMilliseconds();
      }, c.$utils = function() {
        return g;
      }, c.isValid = function() {
        return this.$d.toString() !== d;
      }, c.isSame = function(i, u) {
        var s = O(i);
        return this.startOf(u) <= s && s <= this.endOf(u);
      }, c.isAfter = function(i, u) {
        return O(i) < this.startOf(u);
      }, c.isBefore = function(i, u) {
        return this.endOf(u) < O(i);
      }, c.$g = function(i, u, s) {
        return g.u(i) ? this[u] : this.set(s, i);
      }, c.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, c.valueOf = function() {
        return this.$d.getTime();
      }, c.startOf = function(i, u) {
        var s = this, h = !!g.u(u) || u, m = g.p(i), p = function(V, w) {
          var j = g.w(s.$u ? Date.UTC(s.$y, w, V) : new Date(s.$y, w, V), s);
          return h ? j : j.endOf(M);
        }, D = function(V, w) {
          return g.w(s.toDate()[V].apply(s.toDate("s"), (h ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(w)), s);
        }, b = this.$W, T = this.$M, E = this.$D, W = "set" + (this.$u ? "UTC" : "");
        switch (m) {
          case x:
            return h ? p(1, 0) : p(31, 11);
          case F:
            return h ? p(1, T) : p(0, T + 1);
          case A:
            var H = this.$locale().weekStart || 0, z = (b < H ? b + 7 : b) - H;
            return p(h ? E - z : E + (6 - z), T);
          case M:
          case U:
            return D(W + "Hours", 0);
          case y:
            return D(W + "Minutes", 1);
          case $:
            return D(W + "Seconds", 2);
          case o:
            return D(W + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, c.endOf = function(i) {
        return this.startOf(i, !1);
      }, c.$set = function(i, u) {
        var s, h = g.p(i), m = "set" + (this.$u ? "UTC" : ""), p = (s = {}, s[M] = m + "Date", s[U] = m + "Date", s[F] = m + "Month", s[x] = m + "FullYear", s[y] = m + "Hours", s[$] = m + "Minutes", s[o] = m + "Seconds", s[l] = m + "Milliseconds", s)[h], D = h === M ? this.$D + (u - this.$W) : u;
        if (h === F || h === x) {
          var b = this.clone().set(U, 1);
          b.$d[p](D), b.init(), this.$d = b.set(U, Math.min(this.$D, b.daysInMonth())).$d;
        } else
          p && this.$d[p](D);
        return this.init(), this;
      }, c.set = function(i, u) {
        return this.clone().$set(i, u);
      }, c.get = function(i) {
        return this[g.p(i)]();
      }, c.add = function(i, u) {
        var s, h = this;
        i = Number(i);
        var m = g.p(u), p = function(T) {
          var E = O(h);
          return g.w(E.date(E.date() + Math.round(T * i)), h);
        };
        if (m === F)
          return this.set(F, this.$M + i);
        if (m === x)
          return this.set(x, this.$y + i);
        if (m === M)
          return p(1);
        if (m === A)
          return p(7);
        var D = (s = {}, s[$] = n, s[y] = a, s[o] = r, s)[m] || 1, b = this.$d.getTime() + i * D;
        return g.w(b, this);
      }, c.subtract = function(i, u) {
        return this.add(-1 * i, u);
      }, c.format = function(i) {
        var u = this, s = this.$locale();
        if (!this.isValid())
          return s.invalidDate || d;
        var h = i || "YYYY-MM-DDTHH:mm:ssZ", m = g.z(this), p = this.$H, D = this.$m, b = this.$M, T = s.weekdays, E = s.months, W = s.meridiem, H = function(w, j, q, X) {
          return w && (w[j] || w(u, h)) || q[j].slice(0, X);
        }, z = function(w) {
          return g.s(p % 12 || 12, w, "0");
        }, V = W || function(w, j, q) {
          var X = w < 12 ? "AM" : "PM";
          return q ? X.toLowerCase() : X;
        };
        return h.replace(_, function(w, j) {
          return j || function(q) {
            switch (q) {
              case "YY":
                return String(u.$y).slice(-2);
              case "YYYY":
                return g.s(u.$y, 4, "0");
              case "M":
                return b + 1;
              case "MM":
                return g.s(b + 1, 2, "0");
              case "MMM":
                return H(s.monthsShort, b, E, 3);
              case "MMMM":
                return H(E, b);
              case "D":
                return u.$D;
              case "DD":
                return g.s(u.$D, 2, "0");
              case "d":
                return String(u.$W);
              case "dd":
                return H(s.weekdaysMin, u.$W, T, 2);
              case "ddd":
                return H(s.weekdaysShort, u.$W, T, 3);
              case "dddd":
                return T[u.$W];
              case "H":
                return String(p);
              case "HH":
                return g.s(p, 2, "0");
              case "h":
                return z(1);
              case "hh":
                return z(2);
              case "a":
                return V(p, D, !0);
              case "A":
                return V(p, D, !1);
              case "m":
                return String(D);
              case "mm":
                return g.s(D, 2, "0");
              case "s":
                return String(u.$s);
              case "ss":
                return g.s(u.$s, 2, "0");
              case "SSS":
                return g.s(u.$ms, 3, "0");
              case "Z":
                return m;
            }
            return null;
          }(w) || m.replace(":", "");
        });
      }, c.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, c.diff = function(i, u, s) {
        var h, m = this, p = g.p(u), D = O(i), b = (D.utcOffset() - this.utcOffset()) * n, T = this - D, E = function() {
          return g.m(m, D);
        };
        switch (p) {
          case x:
            h = E() / 12;
            break;
          case F:
            h = E();
            break;
          case J:
            h = E() / 3;
            break;
          case A:
            h = (T - b) / 6048e5;
            break;
          case M:
            h = (T - b) / 864e5;
            break;
          case y:
            h = T / a;
            break;
          case $:
            h = T / n;
            break;
          case o:
            h = T / r;
            break;
          default:
            h = T;
        }
        return s ? h : g.a(h);
      }, c.daysInMonth = function() {
        return this.endOf(F).$D;
      }, c.$locale = function() {
        return k[this.$L];
      }, c.locale = function(i, u) {
        if (!i)
          return this.$L;
        var s = this.clone(), h = Y(i, u, !0);
        return h && (s.$L = h), s;
      }, c.clone = function() {
        return g.w(this.$d, this);
      }, c.toDate = function() {
        return new Date(this.valueOf());
      }, c.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, c.toISOString = function() {
        return this.$d.toISOString();
      }, c.toString = function() {
        return this.$d.toUTCString();
      }, f;
    }(), ie = Q.prototype;
    return O.prototype = ie, [["$ms", l], ["$s", o], ["$m", $], ["$H", y], ["$W", M], ["$M", F], ["$y", x], ["$D", U]].forEach(function(f) {
      ie[f[1]] = function(c) {
        return this.$g(c, f[0], f[1]);
      };
    }), O.extend = function(f, c) {
      return f.$i || (f(c, Q, O), f.$i = !0), O;
    }, O.locale = Y, O.isDayjs = Z, O.unix = function(f) {
      return O(1e3 * f);
    }, O.en = k[N], O.Ls = k, O.p = {}, O;
  });
})(le);
var be = le.exports;
const R = /* @__PURE__ */ fe(be);
var de = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(oe, function() {
    var r = "minute", n = /[+-]\d\d(?::?\d\d)?/g, a = /([+-]|\d\d)/g;
    return function(l, o, $) {
      var y = o.prototype;
      $.utc = function(d) {
        var C = { date: d, utc: !0, args: arguments };
        return new o(C);
      }, y.utc = function(d) {
        var C = $(this.toDate(), { locale: this.$L, utc: !0 });
        return d ? C.add(this.utcOffset(), r) : C;
      }, y.local = function() {
        return $(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var M = y.parse;
      y.parse = function(d) {
        d.utc && (this.$u = !0), this.$utils().u(d.$offset) || (this.$offset = d.$offset), M.call(this, d);
      };
      var A = y.init;
      y.init = function() {
        if (this.$u) {
          var d = this.$d;
          this.$y = d.getUTCFullYear(), this.$M = d.getUTCMonth(), this.$D = d.getUTCDate(), this.$W = d.getUTCDay(), this.$H = d.getUTCHours(), this.$m = d.getUTCMinutes(), this.$s = d.getUTCSeconds(), this.$ms = d.getUTCMilliseconds();
        } else
          A.call(this);
      };
      var F = y.utcOffset;
      y.utcOffset = function(d, C) {
        var _ = this.$utils().u;
        if (_(d))
          return this.$u ? 0 : _(this.$offset) ? F.call(this) : this.$offset;
        if (typeof d == "string" && (d = function(N) {
          N === void 0 && (N = "");
          var k = N.match(n);
          if (!k)
            return null;
          var P = ("" + k[0]).match(a) || ["-", 0, 0], Z = P[0], Y = 60 * +P[1] + +P[2];
          return Y === 0 ? 0 : Z === "+" ? Y : -Y;
        }(d), d === null))
          return this;
        var L = Math.abs(d) <= 16 ? 60 * d : d, v = this;
        if (C)
          return v.$offset = L, v.$u = d === 0, v;
        if (d !== 0) {
          var K = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (v = this.local().add(L + K, r)).$offset = L, v.$x.$localOffset = K;
        } else
          v = this.utc();
        return v;
      };
      var J = y.format;
      y.format = function(d) {
        var C = d || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return J.call(this, C);
      }, y.valueOf = function() {
        var d = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * d;
      }, y.isUTC = function() {
        return !!this.$u;
      }, y.toISOString = function() {
        return this.toDate().toISOString();
      }, y.toString = function() {
        return this.toDate().toUTCString();
      };
      var x = y.toDate;
      y.toDate = function(d) {
        return d === "s" && this.$offset ? $(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : x.call(this);
      };
      var U = y.diff;
      y.diff = function(d, C, _) {
        if (d && this.$u === d.$u)
          return U.call(this, d, C, _);
        var L = this.local(), v = $(d).local();
        return U.call(L, v, C, _);
      };
    };
  });
})(de);
var Te = de.exports;
const we = /* @__PURE__ */ fe(Te), he = "%[a-f0-9]{2}", se = new RegExp("(" + he + ")|([^%]+?)", "gi"), ce = new RegExp("(" + he + ")+", "gi");
function te(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  const r = e.slice(0, t), n = e.slice(t);
  return Array.prototype.concat.call([], te(r), te(n));
}
function Fe(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    let t = e.match(se) || [];
    for (let r = 1; r < t.length; r++)
      e = te(t, r).join(""), t = e.match(se) || [];
    return e;
  }
}
function Ce(e) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let r = ce.exec(e);
  for (; r; ) {
    try {
      t[r[0]] = decodeURIComponent(r[0]);
    } catch {
      const a = Fe(r[0]);
      a !== r[0] && (t[r[0]] = a);
    }
    r = ce.exec(e);
  }
  t["%C2"] = "�";
  const n = Object.keys(t);
  for (const a of n)
    e = e.replace(new RegExp(a, "g"), t[a]);
  return e;
}
function ve(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return decodeURIComponent(e);
  } catch {
    return Ce(e);
  }
}
function me(e, t) {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "" || t === "")
    return [];
  const r = e.indexOf(t);
  return r === -1 ? [] : [
    e.slice(0, r),
    e.slice(r + t.length)
  ];
}
function Ee(e, t) {
  const r = {};
  if (Array.isArray(t))
    for (const n of t) {
      const a = Object.getOwnPropertyDescriptor(e, n);
      a != null && a.enumerable && Object.defineProperty(r, n, a);
    }
  else
    for (const n of Reflect.ownKeys(e)) {
      const a = Object.getOwnPropertyDescriptor(e, n);
      if (a.enumerable) {
        const l = e[n];
        t(n, l, e) && Object.defineProperty(r, n, a);
      }
    }
  return r;
}
const xe = (e) => e == null, ke = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), re = Symbol("encodeFragmentIdentifier");
function Ae(e) {
  switch (e.arrayFormat) {
    case "index":
      return (t) => (r, n) => {
        const a = r.length;
        return n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
          ...r,
          [S(t, e), "[", a, "]"].join("")
        ] : [
          ...r,
          [S(t, e), "[", S(a, e), "]=", S(n, e)].join("")
        ];
      };
    case "bracket":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [S(t, e), "[]"].join("")
      ] : [
        ...r,
        [S(t, e), "[]=", S(n, e)].join("")
      ];
    case "colon-list-separator":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [S(t, e), ":list="].join("")
      ] : [
        ...r,
        [S(t, e), ":list=", S(n, e)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (r) => (n, a) => a === void 0 || e.skipNull && a === null || e.skipEmptyString && a === "" ? n : (a = a === null ? "" : a, n.length === 0 ? [[S(r, e), t, S(a, e)].join("")] : [[n, S(a, e)].join(e.arrayFormatSeparator)]);
    }
    default:
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        S(t, e)
      ] : [
        ...r,
        [S(t, e), "=", S(n, e)].join("")
      ];
  }
}
function Ue(e) {
  let t;
  switch (e.arrayFormat) {
    case "index":
      return (r, n, a) => {
        if (t = /\[(\d*)]$/.exec(r), r = r.replace(/\[\d*]$/, ""), !t) {
          a[r] = n;
          return;
        }
        a[r] === void 0 && (a[r] = {}), a[r][t[1]] = n;
      };
    case "bracket":
      return (r, n, a) => {
        if (t = /(\[])$/.exec(r), r = r.replace(/\[]$/, ""), !t) {
          a[r] = n;
          return;
        }
        if (a[r] === void 0) {
          a[r] = [n];
          return;
        }
        a[r] = [...a[r], n];
      };
    case "colon-list-separator":
      return (r, n, a) => {
        if (t = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !t) {
          a[r] = n;
          return;
        }
        if (a[r] === void 0) {
          a[r] = [n];
          return;
        }
        a[r] = [...a[r], n];
      };
    case "comma":
    case "separator":
      return (r, n, a) => {
        const l = typeof n == "string" && n.includes(e.arrayFormatSeparator), o = typeof n == "string" && !l && I(n, e).includes(e.arrayFormatSeparator);
        n = o ? I(n, e) : n;
        const $ = l || o ? n.split(e.arrayFormatSeparator).map((y) => I(y, e)) : n === null ? n : I(n, e);
        a[r] = $;
      };
    case "bracket-separator":
      return (r, n, a) => {
        const l = /(\[])$/.test(r);
        if (r = r.replace(/\[]$/, ""), !l) {
          a[r] = n && I(n, e);
          return;
        }
        const o = n === null ? [] : n.split(e.arrayFormatSeparator).map(($) => I($, e));
        if (a[r] === void 0) {
          a[r] = o;
          return;
        }
        a[r] = [...a[r], ...o];
      };
    default:
      return (r, n, a) => {
        if (a[r] === void 0) {
          a[r] = n;
          return;
        }
        a[r] = [...[a[r]].flat(), n];
      };
  }
}
function $e(e) {
  if (typeof e != "string" || e.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function S(e, t) {
  return t.encode ? t.strict ? ke(e) : encodeURIComponent(e) : e;
}
function I(e, t) {
  return t.decode ? ve(e) : e;
}
function ye(e) {
  return Array.isArray(e) ? e.sort() : typeof e == "object" ? ye(Object.keys(e)).sort((t, r) => Number(t) - Number(r)).map((t) => e[t]) : e;
}
function ge(e) {
  const t = e.indexOf("#");
  return t !== -1 && (e = e.slice(0, t)), e;
}
function Ne(e) {
  let t = "";
  const r = e.indexOf("#");
  return r !== -1 && (t = e.slice(r)), t;
}
function ue(e, t) {
  return t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? e = Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") && (e = e.toLowerCase() === "true"), e;
}
function ne(e) {
  e = ge(e);
  const t = e.indexOf("?");
  return t === -1 ? "" : e.slice(t + 1);
}
function ae(e, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    ...t
  }, $e(t.arrayFormatSeparator);
  const r = Ue(t), n = /* @__PURE__ */ Object.create(null);
  if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e))
    return n;
  for (const a of e.split("&")) {
    if (a === "")
      continue;
    const l = t.decode ? a.replaceAll("+", " ") : a;
    let [o, $] = me(l, "=");
    o === void 0 && (o = l), $ = $ === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? $ : I($, t), r(I(o, t), $, n);
  }
  for (const [a, l] of Object.entries(n))
    if (typeof l == "object" && l !== null)
      for (const [o, $] of Object.entries(l))
        l[o] = ue($, t);
    else
      n[a] = ue(l, t);
  return t.sort === !1 ? n : (t.sort === !0 ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce((a, l) => {
    const o = n[l];
    return a[l] = o && typeof o == "object" && !Array.isArray(o) ? ye(o) : o, a;
  }, /* @__PURE__ */ Object.create(null));
}
function pe(e, t) {
  if (!e)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, $e(t.arrayFormatSeparator);
  const r = (o) => t.skipNull && xe(e[o]) || t.skipEmptyString && e[o] === "", n = Ae(t), a = {};
  for (const [o, $] of Object.entries(e))
    r(o) || (a[o] = $);
  const l = Object.keys(a);
  return t.sort !== !1 && l.sort(t.sort), l.map((o) => {
    const $ = e[o];
    return $ === void 0 ? "" : $ === null ? S(o, t) : Array.isArray($) ? $.length === 0 && t.arrayFormat === "bracket-separator" ? S(o, t) + "[]" : $.reduce(n(o), []).join("&") : S(o, t) + "=" + S($, t);
  }).filter((o) => o.length > 0).join("&");
}
function De(e, t) {
  var a;
  t = {
    decode: !0,
    ...t
  };
  let [r, n] = me(e, "#");
  return r === void 0 && (r = e), {
    url: ((a = r == null ? void 0 : r.split("?")) == null ? void 0 : a[0]) ?? "",
    query: ae(ne(e), t),
    ...t && t.parseFragmentIdentifier && n ? { fragmentIdentifier: I(n, t) } : {}
  };
}
function Se(e, t) {
  t = {
    encode: !0,
    strict: !0,
    [re]: !0,
    ...t
  };
  const r = ge(e.url).split("?")[0] || "", n = ne(e.url), a = {
    ...ae(n, { sort: !1 }),
    ...e.query
  };
  let l = pe(a, t);
  l && (l = `?${l}`);
  let o = Ne(e.url);
  if (typeof e.fragmentIdentifier == "string") {
    const $ = new URL(r);
    $.hash = e.fragmentIdentifier, o = t[re] ? $.hash : `#${e.fragmentIdentifier}`;
  }
  return `${r}${l}${o}`;
}
function Me(e, t, r) {
  r = {
    parseFragmentIdentifier: !0,
    [re]: !1,
    ...r
  };
  const { url: n, query: a, fragmentIdentifier: l } = De(e, r);
  return Se({
    url: n,
    query: Ee(a, t),
    fragmentIdentifier: l
  }, r);
}
function Ie(e, t, r) {
  const n = Array.isArray(t) ? (a) => !t.includes(a) : (a, l) => !t(a, l);
  return Me(e, n, r);
}
const Ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: Ie,
  extract: ne,
  parse: ae,
  parseUrl: De,
  pick: Me,
  stringify: pe,
  stringifyUrl: Se
}, Symbol.toStringTag, { value: "Module" })), Oe = {
  dateTimeLocal: "YYYY-MM-DD[T]HH:mm:ss",
  dateTimeUTC: "YYYYMMDD[T]HHmmss[Z]",
  allDay: "YYYYMMDD"
};
function B({ startTime: e, endTime: t }, r) {
  const n = Oe[r];
  return { start: e.format(n), end: t.format(n) };
}
R.extend(we);
const ee = Ye.stringify;
function G(e, t = !0) {
  const { start: r, end: n, duration: a, ...l } = e, o = t ? R(r).utc() : R(r), $ = n ? t ? R(n).utc() : R(n) : (() => {
    if (e.allDay)
      return o.add(1, "day");
    if (a && a.length == 2) {
      const y = Number(a[0]), M = a[1];
      return o.add(y, M);
    }
    return t ? R().utc() : R();
  })();
  return {
    ...l,
    startTime: o,
    endTime: $
  };
}
function je(e) {
  const t = G(e), { start: r, end: n } = B(
    t,
    t.allDay ? "allDay" : "dateTimeUTC"
  ), a = {
    action: "TEMPLATE",
    text: t.title,
    details: t.description,
    location: t.location,
    trp: t.busy,
    dates: r + "/" + n,
    recur: t.rRule ? "RRULE:" + t.rRule : void 0
  };
  return t.guests && t.guests.length && (a.add = t.guests.join()), `https://calendar.google.com/calendar/render?${ee(a)}`;
}
function Re(e) {
  const t = G(e, !1), { start: r, end: n } = B(t, "dateTimeLocal"), a = {
    path: "/calendar/action/compose",
    rru: "addevent",
    startdt: r,
    enddt: n,
    subject: t.title,
    body: t.description,
    location: t.location,
    allday: t.allDay || !1
  };
  return `https://outlook.live.com/calendar/0/action/compose?${ee(a)}`;
}
function _e(e) {
  const t = G(e, !1), { start: r, end: n } = B(t, "dateTimeLocal"), a = {
    path: "/calendar/action/compose",
    rru: "addevent",
    startdt: r,
    enddt: n,
    subject: t.title,
    body: t.description,
    location: t.location,
    allday: t.allDay || !1
  };
  return `https://outlook.live.com/calendar/0/deeplink/compose?${ee(a)}`;
}
function Le(e) {
  const t = G(e), { start: r, end: n } = B(
    t,
    t.allDay ? "allDay" : "dateTimeUTC"
  ), a = {
    v: 60,
    title: t.title,
    st: r,
    et: n,
    desc: t.description,
    in_loc: t.location,
    dur: t.allDay ? "allday" : !1
  };
  return `https://calendar.yahoo.com/?${ee(a)}`;
}
function He(e) {
  const t = G(e), r = (t.description || "").replace(/,/gm, ",").replace(/;/gm, ";").replace(/\r\n/gm, `
`).replace(/\n/gm, "\\n").replace(/(\\n)[\s\t]+/gm, "\\n"), n = (t.location || "").replace(/,/gm, ",").replace(/;/gm, ";").replace(/\r\n/gm, `
`).replace(/\n/gm, "\\n").replace(/(\\n)[\s\t]+/gm, "\\n"), { start: a, end: l } = B(
    t,
    t.allDay ? "allDay" : "dateTimeUTC"
  ), o = R(/* @__PURE__ */ new Date()).utc().format(Oe.dateTimeUTC), $ = [
    {
      key: "BEGIN",
      value: "VCALENDAR"
    },
    {
      key: "VERSION",
      value: "2.0"
    },
    {
      key: "PRODID",
      value: t.title
    },
    {
      key: "BEGIN",
      value: "VEVENT"
    },
    {
      key: "URL",
      value: t.url
    },
    {
      key: "DTSTART",
      value: a
    },
    {
      key: "DTEND",
      value: l
    },
    {
      key: "DTSTAMP",
      value: o
    },
    {
      key: "RRULE",
      value: t.rRule
    },
    {
      key: "SUMMARY",
      value: t.title
    },
    {
      key: "DESCRIPTION",
      value: r
    },
    {
      key: "LOCATION",
      value: n
    },
    {
      key: "ORGANIZER",
      value: t.organizer
    },
    {
      key: "UID",
      value: Math.floor(Math.random() * 1e5).toString().replace(".", "")
    },
    {
      key: "END",
      value: "VEVENT"
    },
    {
      key: "END",
      value: "VCALENDAR"
    }
  ];
  let y = "";
  return $.forEach((M) => {
    if (M.value)
      if (M.key == "ORGANIZER") {
        const A = M.value;
        y += `${M.key};${encodeURIComponent(
          `CN=${A.name}:MAILTO:${A.email}\r
`
        )}`;
      } else
        y += `${M.key}:${encodeURIComponent(`${M.value}\r
`)}`;
  }), `data:text/calendar;charset=utf8,${y}`;
}
function Ve() {
  const e = (r, n) => {
    let a = "";
    const l = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    switch (r) {
      case "google":
        a = je(n);
        break;
      case "apple":
        a = He(n);
        break;
      case "yahoo":
        a = Le(n);
        break;
      case "outlook":
        a = l ? _e(n) : Re(n);
        break;
    }
    return a;
  };
  return {
    generateCalendarUrl: e,
    addToCalendar: (r, n, a = !0) => {
      const l = e(r, n);
      a ? window.open(l, "_blank") : window.location.href = l;
    }
  };
}
export {
  Ve as useCalendarSync
};
//# sourceMappingURL=index.js.map
